import React from "react";

type Props = {};

const CustomFooter = (props: Props) => {
  return <div>CustomFooter</div>;
};

export default CustomFooter;
